<template>
  <div>
    <el-autocomplete
        v-model="userName"
        v-bind="$attrs"
        v-on="$listeners"
        :fetch-suggestions="querySearchAsync"
        style="width: 100%"
        :placeholder="placeholder"
        clearable
        @select="handleSelect"
        @clear="clearSelect"
    >
    </el-autocomplete>
  </div>
</template>

<script>
import {userSearch} from "@/api/user";

export default {
  name: "UserSearch",
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    placeholder: {
      type: String,
      default() {
        return '请输入用户关键字'
      }
    },
    size: {
      type: String,
      default() {
        return 'mini'
      }
    }
  },
  data() {
    return {
      userName: this.name
    }
  },
  watch: {
    name: function (newVal, oldVal) {
      if (newVal !== oldVal)
        this.userName = newVal
    },
    userName: function (newVal, oldVal) {
      if (newVal !== oldVal)
        this.$emit('update:name', newVal)
    }
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      if (this.userName) {
        const list = await userSearch({search: this.userName}).then((res) => {
          return res.model.data
        })
        cb(list)
      } else {
        cb([])
      }
    },
    // 处理搜索结果的选中
    handleSelect(item) {
      this.$emit('handleSelect', item)
    },
    clearSelect: function () {
      this.$emit('handleSelect', {})
    }
  }

}
</script>

<style scoped>

</style>